import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import store, { persistor } from './redux/createStore';
import App from './App';

const isProduction = process.env.NODE_ENV === 'production';
Sentry.init({
  dsn:
    'https://eb0189fa95d94617a54d2e611b8fa0b5@o477048.ingest.sentry.io/5517427',
  integrations: [new Integrations.BrowserTracing()],
  environment: isProduction ? 'production' : 'development',

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('app'),
);
